module.exports = __webpack_public_path__ + "static/media/5@2x.159723a0.png";